import { render, staticRenderFns } from "./DiseaseTab.vue?vue&type=template&id=cf7ed55a&scoped=true&"
import script from "./DiseaseTab.vue?vue&type=script&lang=js&"
export * from "./DiseaseTab.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseTab.vue?vue&type=style&index=0&id=cf7ed55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7ed55a",
  null
  
)

export default component.exports